export default function Shop() {
  return (
    <>
      <h1>SHOP UNAVAILABLE</h1>
      <a href="/">Back</a>
    </>
  );
}
